import React from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import GoogleIcon from '@mui/icons-material/Google';
import { projectAuth } from './../firebase/config';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";


const styleAuthModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontFamily: 'Bebas Neue',
  width: 400,
  height: 500,
  bgcolor: '#0E0E10',
  color: '#6ecabe',
  border: '2px solid #6ecabe',
  borderRadius: '3%',
  boxShadow: 24,
  textAlign: 'center',
  p: 4,
};

export default function AuthModal(props) {

  const loginWithGoogle = async () => {

    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(projectAuth, provider)
      const { user } = result;
      console.log(user);
      props.setLoggedIn(true);
      props.setUsername(user.displayName);
      props.handleAuthModalOpen();
      props.setUserEmail(user.email);
      return (1);
    }
    catch (error) {
      const errorMessage = error.message;
      const { email } = error;
      console.log(errorMessage, email);
      return (0);
    };
  }

  return (
    <>
      <Modal
        open={props.authModalOpen && true}
        onClose={props.handleAuthModalOpen}
        aria-labelledby="auth-modal"
      >
        <Box sx={styleAuthModal}>
          <Typography id="add-task-title" variant="h5" component="h4">
            login / signup
          </Typography>
          <br />
          <Box
            component="form"
            sx={{
              width: 900,
              maxWidth: '100%',
            }}
            noValidate
            autoComplete="off"
          >
            <TextField sx={{
              color: '#6ecabe'
            }} id="outlined-basic" label="username" variant="outlined" focused />
            <br />
            <TextField color="primary" id="filled-basic" label="password" variant="filled" />
          </Box>
          <br />
          <Button sx={{
            color: 'black',
            backgroundColor: '#6ecabe',
            textTransform: 'none',
            border: '2px solid #6ecabe',
            '&:hover': {
              backgroundColor: '#0E0E10',
              color: '#6ecabe',
            }
          }}>login</Button>
          <br />
          <Button sx={{
            color: 'black',
            backgroundColor: '#6ecabe',
            marginTop: '6%',
            textTransform: 'none',
            border: '2px solid #6ecabe',
            '&:hover': {
              backgroundColor: '#0E0E10',
              color: '#6ecabe',
            }
          }} endIcon={<GoogleIcon />} onClick={loginWithGoogle}>sign in with </Button>
        </Box>
      </Modal>
    </>
  );
}